import BasicPillar from './BasicPillar.jsx'

/**
 * Growth pillar.
 *
 * 7 goals across sales, marketing, and partnerships. Uses section
 * dividers (goal entries with `type: 'section'`) to group related goals,
 * which BasicPillar renders via SectionDivider.
 *
 * The "Improve Homepage Ranking To Top 10" goal is auto-synced from
 * Google Search Console — its progress bar tracks the live homepage
 * average position. The sync is handled inside GoalCard via
 * useGscGoalSync (name-detected, so no schema changes).
 */
export default function GrowthPillar() {
  return (
    <BasicPillar
      pillarId="growth"
      description={
        'Q2 2026 growth goals: pipeline, marketing, referral partnerships. The Homepage Ranking goal pulls live position data from Google Search Console.'
      }
    />
  )
}
